import { Flex, FlexProps } from '@mantine/core';
import { PropsWithChildren } from 'react';

/**
 * A useful standard component that will normally wrap the main content of the PrimaryLayout.
 * It might be omitted for some pages that need to use the full width of the screen.
 *
 * @param props Component props
 * @returns Component
 */
export const ContentPanel = ({ children, ...props }: PropsWithChildren<FlexProps>) => (
	<Flex direction="column" p="lg" align="center" justify="flex-start" w="100%" flex={1} {...props}>
		{children}
	</Flex>
);
